import { G } from '@mobily/ts-belt';

type EmployeeIdentifierRow = {
  nir?: string | null;
  ntt?: string | null;
};

export type DuplicateEmployeeIdentifier = {
  identifier: string;
  firstLine: number;
  line: number;
};

export function findDuplicateEmployeeIdentifier(
  rows: EmployeeIdentifierRow[],
  dataStartingLine: number,
): DuplicateEmployeeIdentifier | null {
  const firstLineByNir = new Map<string, number>();
  const firstLineByNtt = new Map<string, number>();

  for (const [index, row] of rows.entries()) {
    const line = index + dataStartingLine;
    const duplicate =
      findDuplicateForValue(row.nir, firstLineByNir, line) ??
      findDuplicateForValue(row.ntt, firstLineByNtt, line);

    if (G.isNotNullable(duplicate)) {
      return duplicate;
    }
  }

  return null;
}

function findDuplicateForValue(
  value: string | null | undefined,
  firstLineByValue: Map<string, number>,
  line: number,
): DuplicateEmployeeIdentifier | null {
  if (G.isNullable(value) || value === '') {
    return null;
  }

  const firstLine = firstLineByValue.get(value);
  if (G.isNotNullable(firstLine)) {
    return { identifier: value, firstLine, line };
  }

  firstLineByValue.set(value, line);
  return null;
}
